import { Select } from './';

import React from 'react';
import PropTypes from 'prop-types';

const TeamSelect = ({ meta, ...props }) => (
  <Select
    options={meta.teams.map(({ id, primaryKey, name, abbreviation }) => ({
      key: id,
      value: primaryKey,
      text: name,
      description: abbreviation,
    }))}
    placeholder="Team"
    {...props}
  />
);

TeamSelect.propTypes = {
  meta: PropTypes.shape({
    teams: PropTypes.array.isRequired,
  }).isRequired,
};

export default TeamSelect;



// WEBPACK FOOTER //
// ./src/components/TeamSelect.js